import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from '../../types';
import { searchTags, createTag } from '../../api';
import UnifiedAutocomplete from './UnifiedAutocomplete';

interface TagAutocompleteProps {
  selectedTags: Tag[];
  onTagSelect: (tag: Tag) => void;
  onTagRemove: (tagId: number) => void;
  placeholder?: string;
}

const TagAutocomplete: React.FC<TagAutocompleteProps> = ({
  selectedTags,
  onTagSelect,
  onTagRemove,
  placeholder
}) => {
  const { t } = useTranslation();
  const defaultPlaceholder = placeholder || t('placeholder.searchOrAddTag');

  return (
    <UnifiedAutocomplete<Tag>
      mode="multi"
      selectedItems={selectedTags}
      onItemSelect={onTagSelect}
      onItemRemove={onTagRemove}
      searchFunction={searchTags}
      createFunction={createTag}
      placeholder={defaultPlaceholder}
      debounceMs={600}
      itemDisplayName={(tag) => tag.name}
      createButtonText={(query) => t('autocomplete.createButtonText', { item: query })}
      searchingText={t('common.searching')}
      noItemsFoundText={(query) => t('autocomplete.noTagsFound', { item: query })}
      selectedItemClassName="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200"
    />
  );
};

export default TagAutocomplete;